import { ref } from 'vue';

// Messello in-app help — shared singleton state for the help drawer + product tour.
// The help content lives on the marketing site (messello.com/help); the drawer
// iframes a chrome-less "embed" version so users stay inside the dashboard.
const HELP_BASE = 'https://messello.com/help';

const drawerOpen = ref(false);
const drawerSlug = ref('');
const drawerTitle = ref('');
const tourActive = ref(false);

export function useMesselloHelp() {
  const openHelp = (slug, title = '') => {
    drawerSlug.value = slug;
    drawerTitle.value = title;
    drawerOpen.value = true;
  };
  const closeHelp = () => {
    drawerOpen.value = false;
  };
  const embedUrl = () => `${HELP_BASE}/embed/${drawerSlug.value}`;
  const fullUrl = () => `${HELP_BASE}/${drawerSlug.value}`;
  const startTour = () => {
    drawerOpen.value = false;
    tourActive.value = true;
  };
  const stopTour = () => {
    tourActive.value = false;
  };

  return {
    HELP_BASE,
    drawerOpen,
    drawerSlug,
    drawerTitle,
    openHelp,
    closeHelp,
    embedUrl,
    fullUrl,
    tourActive,
    startTour,
    stopTour,
  };
}
